import moment from 'moment';
import { PaymentLine } from '../../../../core-module/services/payments/types';

export const formatPrice = (value: number) => {
  const formatted = new Intl.NumberFormat('nl-NL', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);

  return `€ ${formatted}`;
};

export const formatDateString = (date: string) => {
  return moment(date).format('DD MMMM YYYY');
};

export const getCalculationFromPaymentLine = (line: PaymentLine) => {
  return `${line.numberOfUnits} x ${formatPrice(line.amountPerUnit)} = ${formatPrice(
    line.totalAmount
  )}`;
};

export const getLabelsFromPaymentLine = (line: PaymentLine) => {
  const list: string[] = [];
  if (line.isSystemCorrectionSplit) {
    list.push('Systeem splitsing');
  }

  if (!line.isCreatedBySystem) {
    list.push('Handmatige correctie');
  }

  return list;
};
